import { angular, app } from '../../app.module'
app
  // 画像遅延読み込み処理
  .directive('imageLazySrc', ($document, $window) => {
    return {
      restrict: 'A',
      link: ($scope, element, $attributes) => {
        let scrollObject
        let listening = false

        // スクロール対象を解決する
        // image-lazy-typeも補間({{}})される場合があり、link時点では未解決のため
        // 属性が解決したあとに呼ぶ必要がある
        function resolveScrollObject() {
          switch ($attributes.imageLazyType) {
            // アカウント詳細モーダルの場合
            case 'accountModal':
              // 対象要素が存在しない場合はwindowにフォールバックする
              return document.getElementById('dialogContent_account-detail') || $window
            // ホーム画面の場合
            case 'home':
              return document.getElementById('activity-list') || $window
            default:
              return $window
          }
        }

        // 要素を透明にしてtransitionするように
        angular.element(element).css('opacity', 0)
        angular.element(element).css('transition', 'opacity 1s linear')

        function isInView() {
          // 補間({{}})された属性はlink時点では未解決のため、値が入るまで判定しない
          // 空のまま判定すると url() という不正値になり、背景画像がセットされずに
          // イベントリスナーだけが外れて復帰しなくなる
          if (!$attributes.imageLazySrc) {
            return
          }

          // クライアントの高さを取得
          const clientHeight: number = $document[0].documentElement.clientHeight
          // クライアントの幅を取得
          const clientWidth: number = $document[0].documentElement.clientWidth
          // 画像の位置を取得
          const imageRect: {
            top: number
            bottom: number
            left: number
            right: number
          } = element[0].getBoundingClientRect()

          if (
            (imageRect.top >= 0 && imageRect.top <= clientHeight) ||
            (imageRect.bottom >= 0 &&
              imageRect.bottom <= clientHeight &&
              imageRect.left >= 0 &&
              imageRect.right <= clientWidth)
          ) {
            // image-lazy-background属性がある場合、背景画像に反映
            // 値なし属性は '' になり truthy 判定では拾えないため、存在有無で判定する
            if ($attributes.imageLazyBackground !== undefined) {
              angular
                .element(element)
                .css('background-image', 'url(' + $attributes.imageLazySrc + ')')
              // 画像を表示
              angular.element(element).css('opacity', 1)
            } else {
              // 指定がない場合、srcに画像を反映
              angular.element(element).attr('src', $attributes.imageLazySrc)
              // 画像を表示
              angular.element(element).css('opacity', 1)
            }

            // 画像セット後、イベントリスナーを削除
            removeEventListeners()
          }
        }

        // イベントリスナーの追加
        function addEventListeners() {
          if (listening) {
            return
          }
          scrollObject = resolveScrollObject()
          scrollObject.addEventListener('scroll', isInView)
          // resizeは要素では発火しないため、常にwindowに紐づける
          $window.addEventListener('resize', isInView)
          listening = true
        }

        // イベントリスナーの削除
        function removeEventListeners() {
          if (!listening) {
            return
          }
          scrollObject.removeEventListener('scroll', isInView)
          $window.removeEventListener('resize', isInView)
          listening = false
        }

        // 要素が破棄された時にイベントリスナーを削除
        element.on('$destroy', () => {
          removeEventListeners()
        })

        // 属性の補間が解決した時点でリスナーを登録し、初回判定を行う
        $attributes.$observe('imageLazySrc', (imageSrc) => {
          if (!imageSrc) {
            return
          }
          addEventListeners()
          isInView()
        })

        // image-lazy-typeの補間はimage-lazy-srcより後に解決されることがあるため、
        // 解決時にスクロール対象を付け替える
        $attributes.$observe('imageLazyType', () => {
          if (!listening) {
            return
          }
          removeEventListeners()
          addEventListeners()
          // 付け替え後は次のscroll/resizeを待たずに再判定する
          isInView()
        })
      },
    }
  })
